module.exports = __webpack_public_path__ + "static/media/Station3.76b3c8c6.png";